// This is a place to house our non-trivial redirects. Any redirect that
// requires processing or data requests will live here.
// Note that this pattern requires the route to be defined in two places.
// This is so that we can lazy-load the redirect logic only when these routes
// are requested.
//
// To add a new redirect route you must do the following:
// 1. Add the route in app-routes.jsx and reference LoadableNontrivialRedirectRoutes
// 2. Add the route again in this file and render using a redirect component
// 3. Add a test to nontrivial-redirect-routes_test.jsx
//
// TODO: Consider some tests to enforce our rules:
// - Routes that come here from Appshell have a route in this switch
// - Routes that are in this switch are in Appshell (reverse)
// - Verifies that we render a supported Redirect code OR Spinner
import * as React from "react";
import {Redirect, Route, Switch} from "react-router-dom";

import LegacyCommonCoreRedirect from "./legacy-common-core-redirect.tsx";
import LegacyExerciseRedirect from "./legacy-exercise-redirect.tsx";
import LegacyModalRedirect from "./legacy-modal-redirect.tsx";

function NontrivialRedirectRoutes(): React.ReactElement {
    return (
        <Switch>
            <Route
                path="*/modal/*"
                render={({location: {pathname, search}}) => (
                    <LegacyModalRedirect path={pathname} search={search} />
                )}
            />
            <Route
                path="/exercise/:slug"
                render={({match: {params}, location: {search}}) => (
                    <LegacyExerciseRedirect
                        exerciseSlug={params.slug}
                        search={search}
                    />
                )}
            />
            <Route
                path="/exercises"
                render={({location: {search}}) => (
                    <LegacyExerciseRedirect
                        exerciseSlug={null}
                        search={search}
                    />
                )}
            />
            <Route
                path="/commoncore/:standardId"
                render={({match: {params}}) => (
                    <LegacyCommonCoreRedirect
                        legacyCode={params?.standardId ?? ""}
                    />
                )}
            />
            {
                // We should not get here.  If we do, redirect to /
            }
            <Redirect to="/" />
        </Switch>
    );
}

export default NontrivialRedirectRoutes;
